import { AuthStateModel } from './models';

export const getIsAuthenticated = (state: AuthStateModel): boolean => {
  return state.isAuthenticated;
};
